import Vue from 'vue'
import Router from 'vue-router'
import admin from './admin'
import gestor from './gestor'
import fornecedor from './fornecedor'
import associado from './associado'
import guest from './guest'
import controleacesso from './controleacesso'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    ...guest,
    ...controleacesso,
    admin,
    gestor,
    fornecedor,
    associado,
    /* LOGIN */
    {
      name: 'login',
      path: '/login',
      component: () => import('@/views/login/Login'),
      meta: {
        // requiresAuth: true,
        permissions: [
          {
            role: 'associado',
            access: false,
            redirect: 'associado',
          },
          {
            role: 'fornecedor',
            access: false,
            redirect: 'fornecedor',
          },
          {
            role: 'gestor',
            access: false,
            redirect: 'gestor',
          },
          {
            role: 'admin',
            access: false,
            redirect: 'admin',
          },
        ],
      },
    },
    /* LANDPAGE */
    {
      name: 'land',
      path: '/',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: 'associado',
            access: false,
            redirect: 'associado',
          },
          {
            role: 'fornecedor',
            access: false,
            redirect: 'fornecedor',
          },
          {
            role: 'gestor',
            access: false,
            redirect: 'gestor',
          },
          {
            role: 'admin',
            access: false,
            redirect: 'admin',
          },
        ],
      },
    },
    /* REDIRECIONAR ROTAS NÃO EXISTENTES PARA PÁGINA INICIAL */
    {
      path: '*',
      redirect: '/',
    },
  ],
})
